let currentTelehealthAudioStream: MediaStream | null = null;
let currentTelehealthAudioStreamHasLocalAudio = false;

export const setTelehealthAudioStream = (
  stream: MediaStream | null,
  options?: { hasLocalAudio?: boolean }
) => {
  currentTelehealthAudioStream = stream;
  currentTelehealthAudioStreamHasLocalAudio =
    !!stream && !!options?.hasLocalAudio;
};

export const getTelehealthAudioStream = (): MediaStream | null => {
  return currentTelehealthAudioStream;
};

export const getTelehealthAudioStreamState = (): {
  stream: MediaStream | null;
  hasLocalAudio: boolean;
} => {
  return {
    stream: currentTelehealthAudioStream,
    hasLocalAudio: currentTelehealthAudioStreamHasLocalAudio,
  };
};
